import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { BaseNewRequestControlName } from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import { DocumentationFormType } from '../../../../shared/base-new-request/base-new-request.model';
import {
  APNEDNewRequestControlName,
  APNEDNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class APNEDNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<APNEDNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonApplicantFormGroup(
        {
          [BaseNewRequestControlName.ContactData]: true,
        },
        {
          documentationFormType: DocumentationFormType.NonElectronicForm,
        },
      ).controls,
      [APNEDNewRequestControlName.ConstructionWorkDefinition]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [APNEDNewRequestControlName.ConstructionWorkBasis]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [APNEDNewRequestControlName.RequestJustification]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
    });
  }
}
